module.exports = __webpack_public_path__ + "img/news-06.0da30b9d.jpg";